export const calculateDistance = (from, to) => {
  if (!from || !to) return null;
  
  const R = 6371e3; // Earth's radius in meters
  const φ1 = from.lat * Math.PI/180;
  const φ2 = to.lat * Math.PI/180;
  const Δφ = (to.lat - from.lat) * Math.PI/180;
  const Δλ = (to.lng - from.lng) * Math.PI/180;

  const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
          Math.cos(φ1) * Math.cos(φ2) *
          Math.sin(Δλ/2) * Math.sin(Δλ/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  return R * c; // Distance in meters
}; 